import { render, staticRenderFns } from "./ProductsSkeleton.vue?vue&type=template&id=63e9fa69&"
import script from "./ProductsSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductsSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSkeleton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports